import { colors } from '@constants/colors';

export const classes = {
  button: {
    width: 40,
    height: 40,
    padding: 0,
    borderRadius: '50%',
    backgroundColor: colors.black,
    border: '0.5px solid rgba(255, 255, 255, 0.15)',
    transition: 'background-color 120ms ease',
    '&:hover': {
      backgroundColor: colors.black_second,
    },
  },
  icon: {
    width: 24,
    height: 24,
    fontSize: 24,
    color: 'rgba(255, 255, 255, 0.8)',
  },
  menuPaper: {
    backgroundColor: colors.black,
    border: '0.5px solid rgba(255, 255, 255, 0.15)',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
    marginTop: '8px',
    minWidth: 160,
  },
  menuList: {
    padding: '4px 0',
  },
  menuItem: {
    padding: '7px 12px',
    fontSize: 14,
    color: colors.white_80,
    '&:hover': {
      backgroundColor: colors.white_10,
    },
    '&.Mui-selected': {
      backgroundColor: colors.white_20,
    },
    '&.Mui-selected:hover': {
      backgroundColor: colors.white_20,
    },
  },
};